// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__jh26D","button":"styles_button__Vxcpa"};